<template>
    <df-app>
        <div slot="page-head" class="d-flex justify-content-between">
            <h2 class="page-head-title">Digital.Cockpit</h2>
            <div class="btn-toolbar">
                <div class="btn-group btn-space mb-2">
                    <button class="btn btn-secondary" v-show="softwareClosed" @click="softwareClosed = softwareFolded = false">Software</button>
                    <button class="btn btn-secondary" v-show="processesClosed" @click="processesClosed = processesFolded = false">Prozesse</button>
                </div>
            </div>
        </div>

        <be-loading :active="!stats">
            <be-card header-contrast featured title="Software" :folded="softwareFolded" :closed="softwareClosed" @header-click="softwareFolded = !softwareFolded">
                <template slot="tools">
                    <span :class="`icon mdi mdi-chart${softwarePie ? '' : '-donut'}`" @click.stop="softwarePie = !softwarePie"></span>
                    <span :class="`icon mdi mdi-chevron-${softwareFolded ? 'up' : 'down'}`" @click.stop="softwareFolded = !softwareFolded"></span>
                    <span class="icon mdi mdi-close" @click.stop="softwareClosed = true"></span>
                </template>
                <be-tabs cards :panes="softwarePanes" slot="body">
                    <template slot-scope="{ pane }">
                        <check-options
                            :title="pane.title"
                            :subtitle="pane.subtitle"
                            :options-key="pane.id"
                            :titleColor="pane.titleColor"
                            :chartColor="pane.chartColor"
                            :view="softwarePie ? 'pie' : 'bar'"
                            :stats="stats"
                        />
                    </template>
                </be-tabs>
            </be-card>
        </be-loading>

        <be-loading :active="!stats">
            <be-card header-contrast featured title="Prozesse" :folded="processesFolded" :closed="processesClosed" @header-click="processesFolded = !processesFolded">
                <template slot="tools">
                    <span :class="`icon mdi mdi-chart${processesPie ? '' : '-donut'}`" @click.stop="processesPie = !processesPie"></span>
                    <span :class="`icon mdi mdi-chevron-${processesFolded ? 'up' : 'down'}`" @click.stop="processesFolded = !processesFolded"></span>
                    <span class="icon mdi mdi-close" @click.stop="processesClosed = true"></span>
                </template>
                <be-tabs cards :panes="processesPanes" slot="body">
                    <template slot-scope="{ pane }">
                        <check-options
                            :title="pane.title"
                            :subtitle="pane.subtitle"
                            :options-key="pane.id"
                            :titleColor="pane.titleColor"
                            :chartColor="pane.chartColor"
                            :view="processesPie ? 'pie' : 'bar'"
                            :stats="stats"
                        />
                    </template>
                </be-tabs>
            </be-card>
        </be-loading>

    </df-app>
</template>

<script>
    import Cockpit from '../../models/Cockpit';

    import CheckOptions from './cockpit/CheckOptions';

    export default {
        components: { CheckOptions },

        data: () => ({
            stats: null,

            softwarePie: false,
            softwareFolded: false,
            softwareClosed: false,
            processesPie: false,
            processesFolded: false,
            processesClosed: false,
        }),

        computed: {
            softwarePanes() {
                return [
                    {
                        id: 'cms',
                        label: 'CMS',
                        title: 'CMS - Content Management Systeme',
                        subtitle: '',
                        titleColor: 'success',
                        chartColor: '52,158,83',
                    },
                    {
                        id: 'dam',
                        label: 'DAM',
                        title: 'DAM - Digital Asset Management',
                        subtitle: '',
                        titleColor: 'warning',
                        chartColor: '247,185,4',
                    },
                    {
                        id: 'pim',
                        label: 'PIM',
                        title: 'PIM - Product Information Management',
                        subtitle: '',
                        titleColor: 'primary',
                        chartColor: '102,161,255',
                    },
                    {
                        id: 'crm',
                        label: 'CRM',
                        title: 'CRM - Customer Relationship Management',
                        subtitle: '',
                        titleColor: 'danger',
                        chartColor: '234,63,48',
                    },
                    {
                        id: 'erp',
                        label: 'ERP',
                        title: 'ERP - Enterprise Ressource Planning',
                        subtitle: '',
                        titleColor: '',
                        chartColor: '158,158,158',
                    },
                ];
            },

            processesPanes() {
                return [
                    {
                        id: 'channels',
                        label: 'Distribution',
                        title: 'Auf welchen Kanälen distribuieren Sie diese Inhalte?',
                        subtitle: 'Wählen Sie alle Kanäle aus, welchen Sie min. einmal pro Jahr mit Informationen updaten.',
                        titleColor: 'success',
                        chartColor: '52,158,83',
                    },
                    {
                        id: 'monitoring',
                        label: 'Erfolgsmessung',
                        title: 'Messen und kennen Sie wichtigsten Kennzahlen Ihrer Online-Kanäle?',
                        subtitle: 'Wählen Sie alle Tools aus, welche Sie für die Erfolgsmessung einsetzen.',
                        titleColor: 'success',
                        chartColor: '52,158,83',
                    },
                ];
            },
        },

        async mounted() {
            const cockpit = await Cockpit.first();

            this.stats = cockpit.check_stats;
        },
    };
</script>
